import React from "react";
import CustomerOtpForm from "./CustomerOtpForm";

export default function SignUpForm({ mode = "signup", onStepChange }) {
  return (
    <CustomerOtpForm
      mode={mode}
      variant="compact"
      onStepChange={onStepChange}
    />
  );
}
